import { lazy } from 'react'
import { Outlet, RouteObject } from 'react-router'

const UserChecklistPage = lazy(() => import( '@/pages/checklist/user-checklist-page.tsx'))
const ChecklistDetailsPage = lazy(() => import( '@/pages/checklist/checklist-details.tsx'))
const HcChecklistPage = lazy(() => import( '@/pages/checklist/hc-checklist-page.tsx'))
const ChecklistConfigPage = lazy(() => import('@/pages/checklist/checklist-config-page.tsx'))
const ChecklistConfigFormPage = lazy(() => import('@/pages/checklist/checklist-config-form-page.tsx'))

export const checklistRoutes: RouteObject = {
  path: 'checklist',
  children: [
    { index: true, element: <HcChecklistPage /> },
    { path: 'config', element: <ChecklistConfigPage /> },
    { path: 'config/new', element: <ChecklistConfigFormPage /> },
    { path: 'config/:id/edit', element: <ChecklistConfigFormPage /> },
  ],
}

export const userChecklistRoutes: RouteObject = {
  path: 'checklist',
  element: <Outlet />,
  children: [
    { index: true, element: <UserChecklistPage /> },
    { path: ':checklistId', element: <ChecklistDetailsPage /> },
  ],
}
